export enum UserRole {
  HotelUser = 0,
  HotelManager = 1
}

// Fallback role values for backward compatibility
export const ROLE_HOTEL_MANAGER = "HotelManager";
export const ROLE_HOTEL_USER = "HotelUser";

export interface User {
  id: number;
  username: string;
  email: string;
  role: UserRole;
  hotelId?: number;
  hotelName?: string;
  token: string;
  assignedZoneIds?: number[];
}

export interface LoginRequest {
  username: string;
  password: string;
  hotelId?: number;
}

export interface CreateUserRequest {
  username: string;
  password: string;
  role: UserRole;
  hotelId?: number;
  assignedZoneIds?: number[];
}

export interface UpdateUserRequest {
  username: string;
  role: UserRole;
  hotelId?: number;
  assignedZoneIds?: number[];
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}
